export const LojaCard = ({infoLoja})=>{
    return <>
            <div className="lojaCard" key={infoLoja.title} style={{'--colorLojaCard': infoLoja.cor}} 
            onClick={()=> {window.location.href = `https://wa.me/${infoLoja.celular}?text=Ol%C3%A1!%20vim%20pelo%20Site%20Babita%20e%20desejo%20saber%20como%20posso%20revender!%20%0AQuero%20entender%20como%20funciona%20o%20atacado%2C%20quais%20s%C3%A3o%20os%20valores%2C%20m%C3%ADnimos%20para%20pedido%20e%20como%20posso%20come%C3%A7ar%20a%20lucrar%20sendo%20revendedora%20Babita.`}}>
                <div className="topCard">
                    <div className="logo" />
                    <p className="lojaTitle">{infoLoja.title}</p>
                </div>
                <p className="infoLoja">
                    <div className="telefone">{infoLoja.telefone}</div>
                    <div className="celular">{infoLoja.celular}</div>
                    <div className="endereco">{infoLoja.endereco}</div>
                    
                    </p>
            </div>
        </>
}

export default LojaCard